import React, { useState } from "react";
import "./pendingpayments.css";

// components imports
import PendingPaymentsTable from "../../../../../Components/BoltTable/BoltTable";
import ImageModal from "../ImageModal/ImageModal";
import ApprovePayment from "../ApprovePayment/ApprovePayment";
import InvoiceModal from "../../../../../Components/InvoiceModal/InvoiceModal";
import {
  convertTime,
  removeUnderscoresAndCapitalize,
} from "../../../../../helpers/helpers";

// apis imports
import { fetchPendingPayments } from "../../../../../services/AdminServices/PaymentsAdmin/payments.services";

// library imports
import { MdOutlineStickyNote2 } from "react-icons/md";
import noImage from "../../../../../assets/images/noImage.png";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import { useTranslation } from "react-i18next";

const PendingPayments = ({ setSnack, snack }) => {
  const { t } = useTranslation("admin");
  const [payments, setPayments] = useState([]);

  const [imageModal, setImageModal] = useState();
  const [invoiceModal, setInvoiceModal] = useState();
  const [approvePaymentModal, setApprovePaymentModal] = useState();
  const [refresh, setRefresh] = useState("0");

  const getShippersPendingPayments = async (page, perPage, filter) => {
    const response = await fetchPendingPayments(page, perPage, filter);
    if (!response.error) {
      setPayments(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 1,
      label: t("payments.clientName"),
      render: (row) => <>{row?.user?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("payments.transactionId"),
      render: (row) => <>{row?.transaction_id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("payments.date"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("payments.paymentType"),
      render: (row) => (
        <>
          {row?.payment_type
            ? removeUnderscoresAndCapitalize(row.payment_type)
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("payments.boltTrackingId"),
      render: (row) => <>{row.shipment?.tracking_id ?? "-"}</>,
      width: "300px",
    },
    {
      id: 6,
      label: t("payments.currentBalance"),
      render: (row) => <>{row?.user?.balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("payments.amountPaid"),
      render: (row) => <>{row?.balance ?? ""}</>,
      width: "200px",
    },
    {
      id: 8,
      label: t("payments.status"),
      field_name: "status",
      render: (row) => <>{row?.status?.toUpperCase() ?? "-"}</>,
      width: "200px",
    },
    {
      id: 9,
      label: t("payments.reference"),
      render: (row) => (
        <>
          {row?.shipment_id ? (
            <div className="table_action__wrap">
              <Tooltip title={t("payments.invoice")}>
                <div
                  className="table_action__btn"
                  onClick={() => setInvoiceModal(row?.shipment_id)}
                >
                  <MdOutlineStickyNote2 size={10} />
                  {t("payments.invoice")}
                </div>
              </Tooltip>
            </div>
          ) : (
            <img
              src={row.file || noImage}
              style={{ cursor: "pointer" }}
              onClick={() => setImageModal(row.file || noImage)}
              onError={(e) => {
                e.target.src = noImage;
              }}
            />
          )}
        </>
      ),
      width: "200px",
    },
    {
      id: 10,
      label: t("payments.createdAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 11,
      label: t("payments.actions"),
      render: (row) => (
        <div className="table_action__wrap">
          <Tooltip title={t("payments.approveBalance")}>
            <div
              className="table_action__btn"
              onClick={() => setApprovePaymentModal(row)}
            >
              <MdOutlineStickyNote2 size={10} />
              {t("payments.approve")}
            </div>
          </Tooltip>
        </div>
      ),
      width: "200px",
      fixed: "right",
    },
  ];
  return (
    <div>
      <div>
        <ImageModal
          open={imageModal}
          setOpen={setImageModal}
          setSnack={setSnack}
        />
        <InvoiceModal
          open={!!invoiceModal}
          data={invoiceModal}
          setOpen={setInvoiceModal}
          // type="editable"
          actions={false}
        />
        <ApprovePayment
          open={!!approvePaymentModal}
          setOpen={setApprovePaymentModal}
          previousData={approvePaymentModal}
          getShippersPendingPayments={() =>
            setRefresh(Math.floor(Math.random() * 100) + 1)
          }
        />
        <PendingPaymentsTable
          tableTitle={t("payments.payments")}
          tableId="pendingPaymentsTableForAdmin"
          message={t("payments.noPaymentsAvailableToDisplay")}
          searchPlaceHolder={t("payments.searchPendingPayments")}
          columns={columns}
          data={payments}
          getAllData={getShippersPendingPayments}
          refresh={refresh}
        />
      </div>
    </div>
  );
};

export default PendingPayments;
